import cn from "clsx"
import { useUnit } from "effector-react"
import { t } from "i18next"
import { $whiteLabel } from "@callcenter/white-label"

import { CALLCENTER_LOGO_WIDTH } from "./constants"

import styles from "./logo.module.pcss"

type LogoProps = {
  className?: string
  href?: string
}

export const Logo = ({ className, href }: LogoProps) => {
  const { brandLogoUrl, omnichannelLogoUrl, brandName } = useUnit($whiteLabel.$whiteLabelSettings)

  const isNativeBrand = brandName?.toLocaleLowerCase() === t("component_component_commonBrandLowercaseOne")

  const Container = href ? "a" : "div"

  return (
    <Container className={cn(styles.container, { [styles.link]: Boolean(href) }, className)} href={href}>
      <img
        className={styles.logo}
        src={brandLogoUrl || omnichannelLogoUrl || ""}
        alt="logo"
        width={isNativeBrand ? CALLCENTER_LOGO_WIDTH : "auto"}
      />
    </Container>
  )
}
